"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markets = exports.Market = void 0;
class Market {
    constructor(market) {
        this.marketId = 0;
        this.symbol = '';
        this.priceDecimals = 0;
        this.amountDecimals = 0;
        this.chart = '';
        this.canTrade = true;
        this.visible = true;
        if (!market) {
            return;
        }
        Object.assign(this, market);
    }
}
exports.Market = Market;
class Markets {
    constructor() {
        this.current = 'BTC-BRL';
        this.list = {};
    }
}
exports.Markets = Markets;
//# sourceMappingURL=market.js.map